/**
 * Health Overview Page
 * Access: All roles
 *
 * Displays personalized health dashboard:
 * - Users: View their own health metrics
 * - Coaches: View selected client's health data
 * - Admins: View any user's health data
 */

export function HealthPage() {
  return (
    <div className="p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-text-dark">
          Health Overview
        </h1>

        <div className="card mb-6">
          <h2 className="text-xl font-semibold mb-2 text-text-dark">
            Welcome to Your Health Journey
          </h2>
          <p className="text-text-secondary">
            Track your metabolic health metrics and monitor your progress over
            time.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mb-8">
          {/* Nutrition Card */}
          <div className="card">
            <h3 className="text-lg font-semibold mb-2 text-text-dark">
              Nutrition
            </h3>
            <p className="mb-4 text-text-secondary">
              Track meals and macronutrient balance
            </p>
            <button className="btn-primary">Log Meal</button>
          </div>

          {/* Exercise Card */}
          <div className="card">
            <h3 className="text-lg font-semibold mb-2 text-text-dark">
              Exercise
            </h3>
            <p className="mb-4 text-text-secondary">
              Record workouts and activity levels
            </p>
            <button className="btn-primary">Log Activity</button>
          </div>

          {/* Sleep Card */}
          <div className="card">
            <h3 className="text-lg font-semibold mb-2 text-text-dark">Sleep</h3>
            <p className="mb-4 text-text-secondary">
              Monitor sleep quality and duration
            </p>
            <button className="btn-primary">Log Sleep</button>
          </div>
        </div>

        {/* Metrics Grid */}
        <div className="grid gap-6 md:grid-cols-4">
          <div className="card text-center">
            <div className="text-3xl font-bold mb-2 text-primary">--</div>
            <div className="text-text-secondary">Blood Glucose (mg/dL)</div>
          </div>
          <div className="card text-center">
            <div className="text-3xl font-bold mb-2 text-secondary">--</div>
            <div className="text-text-secondary">Weight (lbs)</div>
          </div>
          <div className="card text-center">
            <div className="text-3xl font-bold mb-2 text-accent-orange">--</div>
            <div className="text-text-secondary">Waist Circumference (in)</div>
          </div>
          <div className="card text-center">
            <div className="text-3xl font-bold mb-2 text-primary-dark">--</div>
            <div className="text-text-secondary">Blood Pressure</div>
          </div>
        </div>
      </div>
    </div>
  );
}
